module.exports = __webpack_public_path__ + "static/media/icon-lock-blue.ca4b113c.svg";